// Module
var code = "<div class=\"u-sizeFullWidth ui-grid-cell-contents u-textRight\" ng-bind=\"::grid.appScope.TransactionDetail.CustomerLocaleKeys.TRANSACTION_DETAILS.SUB_TOTAL | i18n\"></div>\n";
// Exports
module.exports = code;